import { MenuIcon } from "lucide-react";
import React from "react";
import { SidebarTrigger, useSidebar } from "@/components/ui/sidebar";

/** A settings page's title and actions, like S's page header. Phones open the sidebar from it. */
export function SettingsPageHeader({
  title,
  description,
  children,
}: React.PropsWithChildren<{ title: React.ReactNode; description?: React.ReactNode }>) {
  const { isMobile, open } = useSidebar();
  return (
    <header className="flex shrink-0 flex-col gap-1 px-3 pt-3 pb-2 md:px-4">
      <div className="flex min-h-9 flex-wrap items-center gap-2">
        {(isMobile || !open) && (
          <SidebarTrigger className="shrink-0" icon={isMobile ? MenuIcon : undefined} />
        )}
        <h1 className="min-w-0 text-title font-title">{title}</h1>
        {children && (
          <div className="ms-auto flex min-w-0 flex-wrap items-center justify-end gap-2">
            {children}
          </div>
        )}
      </div>
      {description && <p className="text-sm text-muted-foreground">{description}</p>}
    </header>
  );
}
